import { Component, OnInit } from '@angular/core';
import { EditorService } from "../../../editor.service";
@Component({
  selector: 'app-fillupquestion',
  templateUrl: './fillupquestion.component.html',
  styleUrls: ['./fillupquestion.component.css']
})
export class FillupquestionComponent implements OnInit {

  constructor(private editorService: EditorService) { }
  fillUpAnswer = "answer";
  fillUpWidth;
  isChecked = false;
  textImageData;
  ngOnInit() {
    let cardData = this.editorService.textInlineData;
    if (cardData && cardData.type == "FillBlank") {
      this.textImageData = cardData;
      this.initializeData(cardData)
    }
  }
  initializeData(data) {
    if (data.answer)
      this.fillUpAnswer = data.answer;
    if (data.width)
      this.fillUpWidth = data.width;
    this.isChecked = data.isChecked;
  }

  updateFillQAnswer(evt) {
    if (evt.keyCode == 13) {
      this.updateFillupAnswer();
    }
  }

  updateFillupAnswer() {
    this.updateFillQuestion();
  }
  updateFillupWidth() {
    this.updateFillQuestion();
  }

  checkCaseSensitive() {
    this.isChecked = !this.isChecked;
    this.updateFillQuestion();
  }

  updateFillQuestion() {
    let obj = {
      'answer': this.fillUpAnswer,
      'width': this.fillUpWidth,
      'isCaseSensitive': this.isChecked
    }
    let layer = this.editorService.getIframeReference();
    layer.updateTextQuestionProperties(obj);

  }




}



// WEBPACK FOOTER //
// ./src/app/bookShared/bookeditoption/bookEditOptionPopups/question/fillupquestion/fillupquestion.component.ts